export function andrisEmail(title: string, message: string) {
	return `mailto:andraaspar@gmail.com?subject=${encodeURIComponent(
		title,
	)}&body=${encodeURIComponent(`Szia Andris!\n\nÉpp ezen az oldalon jártam: ${location.href}\n\n` + message)}`
}
